import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { handleError } from '../../../handleError';

export function* loadPrevMessages({
  payload,
  meta: { resolve, reject },
}) {
  try {
    yield effects.put(chatActions.startFetching());
    // const response = yield effects.apply(api, api.get, [
    //   { endpoint: payload.url, direct: true },
    // ]);
    // if (!response.ok) {
    //   reject();
    //   yield throwError(response);
    // }
    //
    // const data = yield effects.call([
    //   response,
    //   'json',
    // ]);

    // yield effects.put(projectsActions.pushPrevMoreMessages({ data, chatId: payload.chatId }));

    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
